import img1 from '../assets/Root/quickmatch__image - 01.png'
import img2 from '../assets/Root/quickmatch__image - 02.png'
import img3 from '../assets/Root/quickmatch__image - 03.png'
import img4 from '../assets/Root/quickmatch__image - 04.png'
import img5 from '../assets/Root/quickmatch__image - 05.png'
import img6 from '../assets/Root/quickmatch__image - 06.png'
import img7 from '../assets/Root/quickmatch__image - 07.png'
import img8 from '../assets/Root/quickmatch__image - 08.png'
import img9 from '../assets/Root/quickmatch__image - 09.png'
import img10 from '../assets/Root/quickmatch__image - 10.png'
import img11 from '../assets/Root/quickmatch__image - 11.png'
import img12 from '../assets/Root/quickmatch__image - 12.png'

export const quickData = [
    {
        img: img1 ,
        text1: "LARGE SCALE BATTLES",
        text2: `The best Vehicle focused Conquest Large Maps.`
    },
    {
        img: img2,
        text1: "THE BATTLEFIELD",
        text2: `Battlefield at its best. Conquest Small, Rush, and Obliteration, with a good balance between infantry and vehicle gameplay.`
    },
    {
        img: img3,
        text1: "CLOSE QUARTERS",
        text2: `Smaller scale infantry focused maps and modes.`
    },
    {
        img: img4,
        text1: "NIGHT OPERATIONS",
        text2: `A tactical mode where flashlights, flares, scopes and other gadgets shine in the dark. <br />
- Take the fight into nightime - as part of the graveyard shift you are re-visiting a familiar but a very different Battlefield.`
    },
    {
        img: img5,
        text1: "NIGHT OPERATIONS LARGE",
        text2: `A tactical mode where flashlights, flares, scopes and other gadgets shine in the dark. <br />
- Take the fight into nightime - as part of the graveyard shift you are re-visiting a familiar but a very different Battlefield.`
    },
    {
        img:img6,
        text1: "NIGHT OPERATIONS LARGE",
        text2: `A tactical mode where flashlights, flares, scopes and other gadgets shine in the dark. <br />
- Take the fight into nightime - as part of the graveyard shift you are re-visiting a familiar but a very different Battlefield.`
    },
    {
        img:img7,
        text1: "NIGHT OPERATIONS INFANTRY",
        text2: `An infantry focused tactical mode where flashlights, flares, scopes and other gadgets shine in the dark. <br />
- Take the fight into nightime - as part of the graveyard shift you are re-visiting a familiar but a very different Battlefield.`
    },
    {
        img:img8,
        text1: "COMMUNITY OPERATIONS",
        text2: `Experience Conquest Small, Rush, Obliteration, CTF, and Chainlink on Operation Outbreak. <br />
- Battlefield at its best with Conquest Small. Rush, Obliteration, Capture the Flag and Chain Link on the jungle map Operation Outbreak.`
    },
    {
        img:img9,
        text1: "COMMUNITY OPERATIONS LARGE",
        text2: `Experience Conquest Large on Operation Outbreak. <br />
- All-out war with Conquest Large on the jungle map Operation Outbreak`
    },
    {
        img: img10,
        text1: "COMMUNITY OPERATIONS INFANTRY",
        text2: `Experience Conquest Large on Operation Outbreak. <br />
- Infantry focused with Team Death Match, Squad Death Match, Domination, and Gun Master on the jungle map Operation Outbreak`
    },
    {
        img: img11,
        text1: "LEGECY OPERATIONS LARGE",
        text2: `Experience Conquest large on Dragon Valley 2015.<br />
- Battlefield at its best with Conquest Small. Rush and Obliteration on the 2015 version of the classic Dragon Valley map`
    },
    {
        img: img12,
        text1: "LEGECY OPERATIONS INFANTRY",
        text2: `Experience Conquest large on Dragon Valley 2015.<br />
- Infantry focused with Team/Squad Death Match, Domination and Gun Master- in the Noshahr Canals inspired Harbor on the 2015 version of the classic Dragon Valley map`
    },
]